import * as React from "react";


const notificationsStructure = {
    defaultOptions: {
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
        timeOut: 2000
    },
    notify: () => {
    }
}

const NotificationsContext = React.createContext(notificationsStructure);


function NotificationsProvider({children}) {
    const [toast, setToast] = React.useState(null);

    React.useEffect(() => {
        let alive = true;

        (async () => {
            const mod = await import("react-toastify");
            if (!alive) return;
            setToast(() => mod.toast);
        })();

        return () => {
            alive = false;
        };
    }, []);

    const notify = React.useCallback((content, type, options = {}) => {
        if (!toast) return; // під час SSR/поки не змонтувалось — нічого не робимо

        const finalOptions = {
            ...notificationsStructure.defaultOptions,
            ...options,
        };

        switch (type) {
            case "error":
                toast.error(content, finalOptions);
                break;
            case "info":
                toast.info(content, finalOptions);
                break;
            case "warning":
                toast.warn(content, finalOptions);
                break;
            default:
                toast.success(content, finalOptions);
                break;
        }
    }, [toast]);


    const value = React.useMemo(
        () => ({...notificationsStructure, notify}),
        [notify]
    );

    return (
        <NotificationsContext.Provider value={value}>
            {children}
        </NotificationsContext.Provider>
    );
}


function useNotifications() {
    return React.useContext(NotificationsContext);
}


export {NotificationsProvider, useNotifications};